import { connect } from 'react-redux';
import PopupEvent from './popup';

export default connect(({ issuesMap, usersMap, trackersMap, overviewByTrackers, curProjectID, account, token }) => ({ issuesMap, usersMap, trackersMap, overviewByTrackers, curProjectID, account, token }))(PopupEvent);


// WEBPACK FOOTER //
// ./src/components/schedule/popup/index.js